const homeRouter = [
  //首页----------------------------------------------------------------------------------------------------------------
  {
    path: 'homePage',
    name: 'homePage',
    component: () => import(/* webpackChunkName: "home/homePage/index" */ '../views/home/homePage/index.vue'),
    meta: { authkey: [] }
  },

  //任务中心----------------------------------------------------------------------------------------------------------------
  //--任务管理 admin
  {
    path: 'taskCenter/admin',
    name: 'taskCenterAdmin',
    component: () => import(/* webpackChunkName: "home/taskCenter/admin/index" */ '../views/home/taskCenter/admin/index.vue'),
    meta: { authkey: [] }
  },

  //内容中心----------------------------------------------------------------------------------------------------------------
  //--内容管理 admin
  {
    path: 'materialsCenter/admin',
    name: 'materialsCenterAdmin',
    component: () => import(/* webpackChunkName: "home/materialsCenter/admin/index" */ '../views/home/materialsCenter/admin/index.vue'),
    meta: { authkey: [] }
  },
  //--内容审核 audit
  {
    path: 'materialsCenter/audit',
    name: 'materialsCenterAudit',
    component: () => import(/* webpackChunkName: "home/materialsCenter/audit/index" */ '../views/home/materialsCenter/audit/index.vue'),
    meta: { authkey: [] }
  },
  //--内容数据 info
  {
    path: 'materialsCenter/info',
    name: 'materialsCenterInfo',
    component: () => import(/* webpackChunkName: "home/materialsCenter/info/index" */ '../views/home/materialsCenter/info/index.vue'),
    meta: { authkey: [] }
  },

  //投放中心----------------------------------------------------------------------------------------------------------------
  //--广告账户管理 advAccountAdmin
  {
    path: 'publishCenter/advAccountAdmin',
    name: 'publishCenterAdvAccountAdmin',
    component: () => import(/* webpackChunkName: "home/publishCenter/advAccountAdmin/index" */ '../views/home/publishCenter/advAccountAdmin/index.vue'),
    meta: { authkey: [] }
  },
  //--投放数据 info
  {
    path: 'publishCenter/info',
    name: 'publishCenterInfo',
    component: () => import(/* webpackChunkName: "home/publishCenter/info/index" */ '../views/home/publishCenter/info/index.vue'),
    meta: { authkey: [] }
  },

  //系统配置----------------------------------------------------------------------------------------------------------------
  //--合作方管理 partnerAdmin
  {
    path: 'systemSetting/partnerAdmin',
    name: 'systemSettingPartnerAdmin',
    component: () => import(/* webpackChunkName: "home/systemSetting/partnerAdmin/index" */ '../views/home/systemSetting/partnerAdmin/index.vue'),
    meta: { authkey: [] }
  },
  //--角色管理 roleAdmin
  {
    path: 'systemSetting/roleAdmin',
    name: 'systemSettingRoleAdmin',
    component: () => import(/* webpackChunkName: "home/systemSetting/roleAdmin/index" */ '../views/home/systemSetting/roleAdmin/index.vue'),
    meta: { authkey: [] }
  },
  //--账号管理 accountAdmin
  {
    path: 'systemSetting/accountAdmin',
    name: 'systemSettingAccountAdmin',
    component: () => import(/* webpackChunkName: "home/systemSetting/accountAdmin/index" */ '../views/home/systemSetting/accountAdmin/index.vue'),
    meta: { authkey: [] }
  },
  //--审批流配置 ApprovalFlow
  {
    path: 'systemSetting/approvalFlow',
    name: 'systemSettingApprovalFlow',
    component: () => import(/* webpackChunkName: "home/systemSetting/approvalFlow/index" */ '../views/home/systemSetting/approvalFlow/index.vue'),
    meta: { authkey: [] }
  },
  //--通知邮箱配置 postMailConfig
  {
    path: 'systemSetting/postMailConfig',
    name: 'systemSettingPostMailConfig',
    component: () => import(/* webpackChunkName: "home/systemSetting/postMailConfig/index" */ '../views/home/systemSetting/postMailConfig/index.vue'),
    meta: { authkey: [] }
  },
  //--MR规范 mrSpec
  {
    path: 'systemSetting/mrSpec',
    name: 'systemSettingMrSpec',
    component: () => import(/* webpackChunkName: "home/systemSetting/mrSpec/index" */ '../views/home/systemSetting/mrSpec/index.vue'),
    meta: { authkey: [] }
  },
  //--客户管理 division
  {
    path: 'systemSetting/division',
    name: 'systemSettingDivision',
    component: () => import(/* webpackChunkName: "home/systemSetting/division/index" */ '../views/home/systemSetting/division/index.vue'),
    meta: { authkey: [] }
  },
  //
  //个人中心----------------------------------------------------------------------------------------------------------------
  {
    path: 'self/center',
    name: 'selfCenter',
    component: () => import(/* webpackChunkName: "home/self/center" */ '../views/home/self/center/index.vue'),
  },
]

homeRouter.push({
  //没有匹配到的路由都进入404页面
  path: 'noPermission',
  name: 'noPermission',
  component: () => import(/* webpackChunkName: "home/errorPage/noPermission" */ '../views/home/errorPage/noPermission.vue'),
});

homeRouter.push({
  //没有匹配到的路由都进入404页面
  path: '*',
  name: 'notFound',
  component: () => import(/* webpackChunkName: "home/errorPage/404" */ '../views/home/errorPage/404.vue'),
});

module.exports = homeRouter;
